import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=7c0aed02&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=7c0aed02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0aed02",
  null
  
)

export default component.exports